  <template>
  <div>
    <v-form :disabled="is_terminated" :readonly="getFormReadOnly()" v-model="enquiryForm" ref="enquiryForm">
    <!-- PERSONAL INFORMATION -->
    <div>
      <p v-if="!currentUser.privileges.canEditOwnEnquiries" class="red--text">You do not have enough permissions to edit this enquiry.</p>
      <p class="font-weight-medium text-left">Personal Information</p>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="* First Name"
                placeholder="eg. John"
                outlined
                class="rounded-input"
                v-model="enquiryDetails.candidate_first_name"
                dense
                :rules="[rules.required, rules.charsOnly, rules.nameLength]"
                
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Middle Name"
                placeholder="eg. Davis"
                outlined
                v-model="enquiryDetails.candidate_middle_name"
                class="rounded-input"
                dense
                :rules="[rules.charsOnly, rules.nameLength]"
                
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Last Name"
                placeholder="eg. Doe"
                v-model="enquiryDetails.candidate_last_name"
                outlined
                class="rounded-input"
                dense
                :rules="[rules.charsOnly, rules.nameLength]"

                
              ></v-text-field>
            </v-col>

            <!-- <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Father's Name"
                placeholder="Placeholder"
                outlined
                class="rounded-input"
                
              ></v-text-field>
            </v-col> -->

            <!-- <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Mother's Name"
                placeholder="Placeholder"
                outlined
                class="rounded-input"
                
              ></v-text-field>
            </v-col> -->

            <v-col cols="12" sm="6" md="4">
              <v-select
                :items="genders"
                label="* Gender"
                v-model="enquiryDetails.gender"
                outlined
                class="rounded-input"
                item-value="value"
                item-text="display"
                :rules="[rules.required]"
                dense
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
    </div>
    <!-- CONTACT INFORMATION -->
    <div>
      <p class="font-weight-medium text-left">Contact Information</p>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="* Phone number"
                placeholder="eg. 9876543210"
                v-model="enquiryDetails.mobileno"
                :rules="[rules.required, rules.numbersOnly, rules.phoneNumberLength]"
                outlined
                dense
                class="rounded-input"
                
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Alternate Number"
                placeholder="eg. 9876543210"
                v-model="enquiryDetails.alternate_mobileno"
                :rules="[rules.numbersOnly, rules.phoneNumberLength]"
                outlined
                dense
                class="rounded-input"
                
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Email"
                placeholder="eg. abc@gmail.com"
                outlined
                class="rounded-input"
                dense
                v-model="enquiryDetails.email"
                :rules="[rules.email]"
                
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
    </div>

    <!-- ACADEMIC INFORMATION -->

    <div>
      <p class="font-weight-medium text-left">Academic Information</p>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <!-- <v-text-field
                label="Standard of Admission"
                placeholder="1st Standard"
                v-model="enquiryDetails.class_standard"
                outlined
                class="rounded-input"
                dense
                
              ></v-text-field> -->
              <v-autocomplete
                :items="class_standards"
                label="* Standard of Admission"
                v-model="enquiryDetails.class_standard"
                outlined
                class="rounded-input"
                item-text="display"
                item-value="id"
                :rules="[rules.requiredClassStandard]"
                return-object
                dense
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Batch"
                placeholder="eg. 2020-2021"
                readonly
                v-model="enquiryDetails.class_standard.academic_session.title"
                hint="Can be changed by selecting different standard of admission"
                outlined
                dense
                class="rounded-input"
                
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
    </div>

    <!-- ACADEMIC HISTORY-->
    <div>
      <p class="font-weight-medium text-left">Academic History</p>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Previous School"
                placeholder="eg. St.Xavier's School"
                outlined
                class="rounded-input"
                v-model="enquiryDetails.previous_school_name"
                dense
                
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Previous Std."
                placeholder="eg. 7th STD"
                :rules="[rules.length10]"
                v-model="enquiryDetails.previous_standard"
                outlined
                dense
                class="rounded-input"
                
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Previous Std. Percentage"
                :rules="[rules.percentage]"
                placeholder="eg. 92.40"
                v-model="enquiryDetails.previous_standard_percentage"
                outlined
                dense
                class="rounded-input"
                
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
    </div>

    <!-- Other Info-->
    <div>
      <p class="font-weight-medium text-left mb-0">Other Information</p>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      :value="formattedDate(enquiryDetails.enquiry_date)"
                      append-icon="fas fa-calendar"
                      readonly
                      outlined
                      label="Enquiry Date"
                      class="rounded-input my-2"
                      dense
                      v-bind="attrs"
                      v-on="on"
                      hide-details="auto"
                    ></v-text-field>
                </template>
                <v-date-picker
                    ref="picker"
                    v-model="enquiryDetails.enquiry_date"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                  </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                :items="enquirySources"
                label="* Enquiry Source"
                v-model="enquiryDetails.source"
                outlined
                class="rounded-input my-2"
                item-text="name"
                item-value="id"
                :rules="[rules.required]"
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-checkbox
                v-model="enquiryDetails.is_specially_abled"
                label="Specially Abled Candidate"
              ></v-checkbox>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="Remarks"
                outlined
                class="rounded-input my-2"
                v-model="enquiryDetails.note"
                dense
                hide-details="auto"
                auto-grow
                rows="3"
              ></v-textarea>
            </v-col>
            
          </v-row>
        </v-container>
    </div>
    </v-form>
    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import moment from 'moment';


export default {
  name: "EnquiryStepperContent",
  props: {
    enquiryDetails: {
      default: () => {
        return {
          candidate_first_name: null,
          candidate_middle_name: null,
          candidate_last_name: null,
          gender: {},
          mobileno: null,
          alternate_mobileno: null,
          class_standard: {
            academic_session: {
              title: null,
            },
          },
          source: {
            name: null,
          },
          email: null,
          creator: {
            id: null,
          },
          previous_school_name: null,
          previous_standard: null,
          previous_standard_percentage: null,
          enquiry_date: new Date(),
          is_specially_abled: null,
          note: null,
          snackbar: {
            visible: false,
            text: "",
          },
        };
      },
      type: Object,
    },
    is_terminated: {
      default: true,
      type: Boolean,
    },
    is_from_portal: {
      default: false,
      type: Boolean,
    },
    class_standards : {
      default: () => [],
      type: Array,
    },
    enquirySources : {
      default: () => [],
      type: Array,
    },
    is_editing: {
      default: false,
      type: Boolean,
    },
    admission_id: null,
  },
  data() {
    return {
      enquiryForm: false,
      menu: false,
      moment: moment,
      genders: [
        {
          display: "Male",
          value: "M",
        },
        {
          display: "Female",
          value: "F",
        },
        {
          display: "Other",
          value: "O",
        },
      ],
      rules: {
        required: (v) => !!v || "Required",
        requiredClassStandard: (v) => !!v.id || "Required",
        requiredList: (v) => v.length > 0 || "Required",
        fullNameLength: (v) => !v || v?.length<=70 || "Too Long",
        nameLength: (v) => !v || v?.length<=40 || "Max length is 40",
        charsOnly: (v) => !/[^a-zA-Z. ]/.test(v) || "Invalid",
        usernameValidation: (v) => !v || !/[^a-zA-Z0-9.]/.test(v) || "Invalid",
        numbersOnly: (v) => !v || !/[^0-9]/.test(v) || "Invalid",
        phoneNumberLength: (v) => !v || v?.length == 10 || "Should be 10 Digits",
        emailOnly: (v) => /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/.test(v)|| !v || "Not a valid email",
        length30 : (v) => !v || v?.length<=30 || "Too long",
        length10: (v) => !v || v?.length<=10 || "Max 10 digits",
        email: (v) => !v || /.+@.+\..+/.test(v) || 'E-mail must be valid',
        percentage: (v) => /(100(\.0{1,2})?$)|^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$/.test(v)|| !v || "Enter valid percentage"      
      },
      snackbar: {
        visible: false,
        text: "",
      },
    };
  },
  computed:{
    ...mapGetters(["accessToken", "currentUser"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },
  methods:{
    ...mapActions(["setLoading"]),

    getFormReadOnly(){
      // return true
      // Add privilege if required
      if(this.is_from_portal){
        return false
      }
      return this.is_editing && this.enquiryDetails.creator.id != this.currentUser.id ? !this.currentUser.privileges.canEditAllEnquiries : !this.currentUser.privileges.canEditOwnEnquiries
    },

    formattedDate(date) {
      if (!date) return "";
      return moment(date).format("D MMM YYYY");
    },
    
    // Do not TOUCH or change names 
    async saveFormDetails(){
      if(!this.enquiryForm){
        alert("Form Not Valid");
        return;
      }
      var url = endpoints.admissions + "enquiry/";
      var post_body = {
        enquiry_details: this.enquiryDetails,
        is_editing: this.is_editing,
        admission_id: this.admission_id,
      }
      var response = await api.call(this.apiEssentials,url,api.Methods.POST, post_body);
      if (response instanceof Error){
        this.setLoading(false);
        this.snackbar.text = "Error saving details";
        this.snackbar.visible = true;
        return;
      }
      // this.$router.push({name: 'EditAdmissionDetails', params: { admission_id: response.id }});
      this.snackbar.text = "Enquiry Successfully Saved!";
      this.snackbar.visible = true;
      this.$emit("save-response",{ step: 1 ,name: 'enquiryDetails', value: response});
      this.enquiryForm = false;
      // this.$refs.enquiryForm.resetValidation()
    },
  },
  watch:{
    // DO NOT TOUCH
    enquiryForm(){
      this.$emit("form-change",{ step: 1 ,name: 'enquiryForm', is_valid: this.enquiryForm});
    },
    enquiryDetails:{
      handler(){
        var form = this.$refs.enquiryForm.validate()
        if(form){
          this.enquiryForm = true
        }
        this.$emit("form-change",{ step: 1 ,name: 'enquiryForm', is_valid: this.enquiryForm});

      },
      deep: true,
    },
  },
  created(){
    this.$emit("form-change",{ step: 1 ,name: 'enquiryForm', is_valid: this.enquiryForm});
  }
};
</script>

<style>
</style>